import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router'
import {Form, Field} from 'simple-react-form'
import map from 'lodash/map'
import Checkbox from 'App/components/fields/Checkbox'
import Save from './Save'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import Email from 'App/components/fields/Email'
import Rut from 'App/components/fields/Rut'
import PhoneNumber from 'App/components/fields/PhoneNumber'

@withRouter
export default class Fields extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    document: PropTypes.object
  }

  state = {}

  componentDidMount() {
    let object = {}
    const values = this.props.document.fieldsValues || []
    map(this.props.document.fieldsName, function(fvalue, key) {
      object[key] = values[key]
    })
    this.setState(object)
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="content">
          <div className={styles.subTitle}>
            El documento contiene los siguientes campos con nombres asignados:
          </div>
          <Form state={this.state} onChange={changes => this.setState(changes)}>
            {map(this.props.document.fieldsName, function(fvalue, key) {
              if (fvalue === 'text') {
                return (
                  <div className={styles.form} key={key}>
                    {key}
                    <Field fieldName={key} placeholder={'Agregar información'} type={Text} />
                    <br />
                  </div>
                )
              }
              if (fvalue === 'rut') {
                return (
                  <div className={styles.form} key={key}>
                    {key}
                    <br />
                    <Field fieldName={key} placeholder={'Agregar información'} type={Rut} />
                  </div>
                )
              }
              if (fvalue === 'email') {
                return (
                  <div className={styles.form} key={key}>
                    {key}
                    <br />
                    <Field fieldName={key} placeholder={'Agregar información'} type={Email} />
                  </div>
                )
              }
              if (fvalue === 'telefono') {
                return (
                  <div className={styles.form} key={key}>
                    {key}
                    <br />
                    <Field fieldName={key} placeholder={'Agregar información'} type={PhoneNumber} />
                  </div>
                )
              }
              if (fvalue === 'checkbox') {
                return (
                  <div className={styles.form} key={key}>
                    <div className="row">
                      <div className="col-xs-12 col-sm-2" style={{paddingTop: 7}}>
                        {key}
                      </div>
                      <div className="col-xs-12 col-sm-9">
                        <Field fieldName={key} type={Checkbox} />
                        <br />
                      </div>
                    </div>
                  </div>
                )
              }
            })}
          </Form>
          <br />
          <Save value={this.state} document={this.props.document} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/FillNameFields/Fields/index.js